import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form__group form__group--checkbox"
}
const _hoisted_2 = { class: "relative inline-flex items-center justify-center self-start" }
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", { class: "custom-checkbox icon text-creation-background w-3.5 h-3.5 stroke-[3] absolute" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#check" })
], -1)
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "form__group form__group--checkbox"
}
const _hoisted_7 = { class: "relative inline-flex items-center justify-center self-start" }
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", { class: "custom-checkbox icon text-creation-background w-3.5 h-3.5 stroke-[3] absolute" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#check" })
], -1)
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.campaign.enforcesTermsAndConditionsConsent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("label", null, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("input", {
                id: "terms",
                type: "checkbox",
                value: _ctx.termsAndConditionsConsentGiven,
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.termsAndConditionsConsentGivenChanged && _ctx.termsAndConditionsConsentGivenChanged(...args)))
              }, null, 40, _hoisted_3),
              _hoisted_4
            ]),
            _createElementVNode("span", { innerHTML: _ctx.termsAndConditionsConsentText }, null, 8, _hoisted_5)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.campaign.enforcesPrivacyPolicyConsent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("label", null, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("input", {
                id: "terms",
                type: "checkbox",
                value: _ctx.privacyPolicyAccepted,
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.privacyPolicyAcceptedChanged && _ctx.privacyPolicyAcceptedChanged(...args)))
              }, null, 40, _hoisted_8),
              _hoisted_9
            ]),
            _createElementVNode("span", { innerHTML: _ctx.privacyPolicyText }, null, 8, _hoisted_10)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}